import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { Select, Store } from '@ngxs/store';
import { FamilyEntity, NetworkMember, Time, CommonService, Config, PatientEntity, GetFamilyById, SaveFamily } from 'huddyapi';

import moment_ from 'moment';
import { EditPatientDialog } from '../../components/edit-patient-dialog/edit-patient-dialog.component';
import { EditFamilyDialog } from '../../components/edit-family-dialog/edit-family-dialog-component';
import { FormArray, UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { Util } from "../../components/util";



const moment = moment_;

@Component({
  selector: 'family-patients',
  templateUrl: './family-patients.component.html',
  styleUrls: ['./family-patients.component.scss']
})
export class FamilyPatientsComponent implements OnInit {

  @Input() family : FamilyEntity;
  updateFormArray : UntypedFormArray = this.formBuilder.array([]);
  
  updateForm : UntypedFormGroup ;
  familyPatientStatuses : string[] = [
    'NOT_CONSENTED', 'NOT_ELIGIBLE', 'ELIGIBLE', 'ONBOARDED', 'ARCHIVED', 'COMPLETED'
  ];
  constructor(
    private store : Store,
    private config: Config,
    private commonService : CommonService,
    public router: Router,
    public dialog: MatDialog,
    public matIconRegistry : MatIconRegistry,
    private domSanitizer : DomSanitizer,
    private formBuilder : UntypedFormBuilder
  ) {
      this.updateForm =   this.formBuilder.group({
        status:  this.updateFormArray
    });

  }

  ngOnInit(): void {
    this.setForm();
  }

  ngOnChanges(changes : SimpleChanges) {
    if (changes['family']) {
      this.setForm();
    }
  }

  setForm() {
    this.updateFormArray = this.formBuilder.array([]);
    for (let fp of this.family.patients) {
      let group = new UntypedFormGroup({});
      group.addControl('status', new UntypedFormControl(fp.status));
      group.addControl('notes', new UntypedFormControl(fp.notes));
      this.updateFormArray.push(group);
    }
   
  }

  getControl(i : number, field : string) {
    return this.updateFormArray.at(i).get(field) as UntypedFormControl
  }

  getColorFromName(name : string) : string {
    let ret : string = '#DAC7FD';
    if (name) {
      ret = NetworkMember.getColorForName(name);
      if (ret === 'avatarColor0') {
        ret = '#DAC7FD';
      } else if (ret === 'avatarColor1') {
        ret = '#F06D82';
      } else if (ret === 'avatarColor2') {
        ret = '#75C5EC';
      } else if (ret === 'avatarColor3') {
        ret = '#A7C2EF';
      }
    }
    return ret;
  }

  isConsented(p : PatientEntity) {
    return p.consentSignature && p.consentSignature.length > 0;
  }

 getInitial(patient : PatientEntity) {
  let ret : string = 'P';
  if (patient) {
    if (patient.firstName) 
      ret = patient.firstName.substring(0,1);
    else 
      ret = patient.username.substring(0,1);
  }
  return ret;
 }

 getFriendlyName(patient : PatientEntity) {
  //console.log(patient);
  if (!patient) {
    return;
  }
  let ret =  patient.firstName ? patient.firstName + ' ' : '';
  if (patient.lastName)
    ret = ret + patient.lastName;
  return ret;
 }

  onDelete(patient : PatientEntity) {
    // this.store.dispatch(new DeleteReminder(reminder.id)).subscribe(t => {
    //   timer(3000).subscribe(t => this.store.dispatch(new GetReminderForUsername(this.patient.username)));
    // });
  }
  goToPatient(patient : PatientEntity) {
    this.router.navigateByUrl('/patient/' + patient.id);

  }
 
  editPatient(patient : PatientEntity) {
    this.dialog.open(EditPatientDialog, {
      width: '600px',
      height: '575px',
      data: {
        patient: patient,
        fromFamily: true
      }
    });
  }

  onSubmitForm() {
    for (let i =0; i <  this.family.patients.length; i++) {
      const status : string = this.getControl(i, 'status').value;
      const notes : string = this.getControl(i, 'notes').value;
      this.family.patients[i].status = status;
      this.family.patients[i].notes = notes;
    }
    console.log('onbusmitform', this.family);
    this.store.dispatch(new SaveFamily(this.family));
  }

  editFamilyPatients() {
    let familyDialog = this.dialog.open(EditFamilyDialog, {
      width: '600px',
      height: '650px',
      data: {
        family: this.family,
        fromFamilyPatient: true
      }
    });
    familyDialog.afterClosed().subscribe(family =>  this.store.dispatch( new GetFamilyById(this.family.id)));
  }

  sanitizeIdentifier(id: string | undefined): string {
    return Util.sanitizeIdentifier(this.family?.identifier, id);
  }
}